import Alien from '../objects/items/moveable/alien'

const ENERGY_DROP_PER_MS = 0.005;
const ENERGY_ADD_PER_MS = 0.05;
const BASE_SPEED_LY_PER_MS = 0.0001;
const ENERGY_PER_MASS = 10;

export default class GameState {

    howMuchTimeToFly(mass = 0) {
        return Math.min(100, this.energy + this.addEnergy + mass * ENERGY_PER_MASS) / ENERGY_DROP_PER_MS;
    }

    constructor(items) {
        this.distanceLeft = 10;
        this.energy = 0;
        this.items = items;

        this.addEnergy = 0;
        this.paused = false;
        this.dialogShown = false;
        this.eventsResults = {};
        this.timePassed = 0;
        this.logRecords = 0;
        this.rooms = [];
        this.log = [];
        this.history = [];

        this.stoppedTime = 0;
        this.hintsShown = 0;
    }

    setEnergy(exactValue) {
        this.energy = Math.max(0, Math.min(110, exactValue));
        this.addEnergy = 0;
    }

    appendEnergy(energy) {
        this.addEnergy = Math.min(100 - this.energy, energy);
    }

    canUpdateItem() {
        return !this.dialogShown;
    }

    canShowEvent() {
        return !this.paused && !this.hero.holding && !this.items.children.some(ch => ch.flying);
    }

    addLog(text) {
        this.log.push({ text, timeLeft: 10000, printed: "" });

    }

    get speed() { return this.energy ? BASE_SPEED_LY_PER_MS : 0 }
    get relativeSpeed() { return this.speed / BASE_SPEED_LY_PER_MS; }


    findFirstAvailable(type) {
        let found = null;
        this.items.forEach(item => {
            if (found) return;
            if (item.type === type && item.isAvailable && this.isAccessibleRoom(item)) {
                found = item;
            }
        });
        return found;
    }

    has(type) {
        return !!this.findFirstAvailable(type);
    }

    remove(type) {
        this.items.removeItem(this.findFirstAvailable(type));
    }

    generateLogRecordId() {
        return "SHIP LOG RECORD " + this.timePassed.toFixed(3).replace(/,/g, ".") + '.' + (this.logRecords++);
    }

    getRandomRoomWithoutHero() {
        let roomsWithoutHero = this.rooms.filter(r => !r.contains(this.hero) && r.canBeBreached && !r.disabled);
        return game.rnd.pick(roomsWithoutHero);
    }

    createAlienIn(kls, room) {
        let { x, y } = room.randomPoint(20);
        let alien = new kls(x, y);
        this.items.add(alien);
        return alien;
    }

    getRoomWhereHeroIs() {
        return this.rooms.find(r => r.contains(this.hero));
    }

    getRoomOf(point) {
        return this.rooms.find(r => r.contains(point));
    }

    getHolding() {
        return this.hero.holding;
    }

    isAccessibleRoom(item) {
        let room = this.rooms.find(r => r.contains(item));
        return !room || !room.disabled;
    }


    update() {
        if (this.addEnergy) {
            let toAdd = Math.min(this.addEnergy, ENERGY_ADD_PER_MS * game.time.physicsElapsedMS);
            if (this.energy + toAdd < 100) {
                this.addEnergy -= toAdd;
                this.energy += toAdd;
            }
        }
        if (this.paused) return;
        this.log = this.log.filter(rec => {
            rec.timeLeft -= game.time.physicsElapsedMS;
            rec.old = rec.timeLeft < 5000;
            return rec.timeLeft > 0;
        });
        this.timePassed += BASE_SPEED_LY_PER_MS * game.time.physicsElapsedMS;
        this.energy -= ENERGY_DROP_PER_MS * game.time.physicsElapsedMS;
        if (this.energy <= 0) {
            this.energy = 0;
            let oldStoppedTime = this.stoppedTime;
            this.stoppedTime += game.time.physicsElapsedMS;

            let item = this.hero.holding || this.hasAnythingOnShip();
            if (item) {
                if (oldStoppedTime < 20000 && this.stoppedTime > 20000 && this.hintsShown < 3) {
                    this.addLog(item.constructor.label + "> press 'SPACE' and throw me to the furnace!");
                    item.jump();
                    this.hintsShown++;
                } else if (oldStoppedTime < 10000 && this.stoppedTime > 10000 && this.hintsShown < 2) {
                    this.addLog("I think I should throw a " + item.constructor.label + " to the furnace.");
                    item.jump();
                    this.furnace.jump();
                    this.hintsShown++;
                } else if (oldStoppedTime < 5000 && this.stoppedTime > 5000 && this.hintsShown < 1) {
                    this.addLog("I won't go anywhere without burning something in the furnace.");
                    this.furnace.jump();
                    this.hintsShown++;
                }
            }

        } else {
            this.stoppedTime = 0;
        }

        this.distanceLeft -= this.speed * game.time.physicsElapsedMS;
        if (this.distanceLeft <= 0) {
            this.distanceLeft = 0;
        }
    }

    //has special case for Hammer
    hasAnythingOnShip() {
        let found = false;
        this.items.forEach(item => {
            if (found) return;
            if (item.isAvailable && item.canBeBurnedRightNow && this.isAccessibleRoom(item)) {
                found = item;
            }
        });
        return found;
    }

    availableItemsOnShip() {
        return this.items.filter(item => {
            return item.isAvailable && item.canBeBurnedRightNow && this.isAccessibleRoom(item)
        });
    }


    getHoldingEnergy() {
        return this.hero.holding ? this.hero.holding.constructor.mass * ENERGY_PER_MASS : 0;
    }

    onDrop(item) {
        this.appendEnergy(ENERGY_PER_MASS * item.constructor.mass);
    }

    get isWin() {
        return this.distanceLeft <= 0;
    }

    loose(reason = "noenergy") {
        this.loosed = reason;
    }

    win() {
        this.winned = true;
    }

}


// WEBPACK FOOTER //
// ./src/states/game_state.js